<template>
  <div class="TheNavbarJoinCommunity">
    <img
      class="TheNavbarJoinCommunity__image"
      src="../assets/platform.avif"
      alt="Join the community"
    />
    <h1 class="TheNavbarJoinCommunity__title">See Sustainalyse in action!</h1>
    <!-- <p class="TheNavbarJoinCommunity__description">
      Get our free, 5-min monthly newsletter and don’t miss the most important
      regulations in your industry.
    </p> -->

    <div class="TheNavbarJoinCommunity__actions">
      <RouterLink :to="{ name: 'Contact' }">
        <button class="TheNavbarJoinCommunity__action">Book a call</button>
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.TheNavbarJoinCommunity {
  .TheNavbarJoinCommunity__image {
    width: 100%;
  }

  .TheNavbarJoinCommunity__title {
    @include font-size-16px;
    margin-top: 1rem;
    font-weight: 600;
    color: $color-ui-gray-cool-900;
  }

  .TheNavbarJoinCommunity__description {
    @include font-size-14px;
    margin-top: 0.25rem;
    color: $color-ui-gray-cool-600;
  }

  .TheNavbarJoinCommunity__actions {
    margin-top: 0.75rem;
  }

  .TheNavbarJoinCommunity__action {
    @include font-size-14px;
    font-weight: 600;
    color: $color-ui-brand-700;

    &:hover {
      color: $color-ui-brand-500;
    }
  }
}
</style>
